import React from "react";
import { Stack } from "@mui/material";
import { Profile } from "components/Social/Profile/Profile";
import { AssetAllocation } from "components/Social/Asset-allocation/AssetAllocation";
import { AssetClasses } from "components/Social/Asset-classes/AssetClasses";
import { Hobbies } from "components/Social/Hobbies/Hobbies";
import { IndustryExpertise } from "components/Social/Industry-expertise/IndustryExpertise";
import { NotableInvestments } from "components/Social/Notable-investments/NotableInvestments";
import { Interests } from "components/Social/Interests/Interests";
import { useWindowSizeSelector } from "store";
import { useNavigate } from "hooks";
import { RoleComponentGuard } from "components";
import { RoleName } from "../../../constants";
import { AccessDenied } from "components/Access-denied/AccessDenied";
import { IProfileData } from "store/types/user/social";

export interface ISocialComponentProps {
  data: IProfileData;
  btnHandler: () => void;
  btnTitle: string;
  btnIcon?: JSX.Element;
  updatePhotoProfile?: (avatar: File) => void;
  userId?: number;
  userFullName?: string;
  fullWidth?: boolean;
}

export const SocialComponent: React.FC<ISocialComponentProps> = ({
  data,
  btnHandler,
  updatePhotoProfile,
  btnTitle,
  btnIcon,
  userId,
  userFullName,
  fullWidth
}) => {
  const { width: screenWidth } = useWindowSizeSelector();
  const navigate = useNavigate();

  return (
    data && (
      <RoleComponentGuard
        availableRoles={[RoleName.Admin, RoleName.Analyst]}
        RenderInstead={<AccessDenied redirectClick={() => navigate({ route: "main" })} title="Back home" />}
      >
        <Stack
          sx={{
            width: "100%",
            ...(!fullWidth && {
              maxWidth: screenWidth > 1366 ? "900px" : "738px",
              minWidth: screenWidth > 1366 ? "900px" : "738px"
            }),
            padding: "30px",
            backgroundColor: "#edf1f9",
            borderRadius: "10px",
            overflowY: "auto"
          }}
          direction="column"
          gap="35px"
        >
          <Profile
            btnTitle={btnTitle}
            profile={data.details}
            btnHandler={btnHandler}
            updateAvatar={updatePhotoProfile}
            btnIcon={btnIcon}
            userId={userId}
            userFullName={userFullName}
          />
          <AssetAllocation data={data.asset_allocations} />
          <IndustryExpertise data={data.industry_expertises} />
          <Hobbies data={data.hobbies} />
          <AssetClasses data={data.asset_classes} />
          <NotableInvestments data={data.investments} />
          <Interests data={data.interests} />
        </Stack>
      </RoleComponentGuard>
    )
  );
};
